import {createContext, Dispatch, useContext} from 'react'

export type State = [string, string?]

export type ContextType = [State, Dispatch<any>]

export const RouterContext = createContext<ContextType | null>(null)

export const useRouterContext = (): ContextType => {
  const contextValue = useContext(RouterContext)

  if (!contextValue) {
    throw new Error('context not found')
  }

  return contextValue
}
